module.exports = __webpack_public_path__ + "img/111skin1.2db8542d.jpg";